import { render, staticRenderFns } from "./MatchingDirectActionPanel.vue?vue&type=template&id=c0968bea&scoped=true"
import script from "./MatchingDirectActionPanel.vue?vue&type=script&lang=js"
export * from "./MatchingDirectActionPanel.vue?vue&type=script&lang=js"
import style0 from "./MatchingDirectActionPanel.vue?vue&type=style&index=0&id=c0968bea&prod&lang=scss"
import style1 from "./MatchingDirectActionPanel.vue?vue&type=style&index=1&id=c0968bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0968bea",
  null
  
)

export default component.exports